import {Grid, Typography} from "@mui/material";

export default function ManageUserListSettings() {
    return (<>
        <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item sx={{textAlign: "center"}}>
                <Typography variant="h2">Manage Users</Typography>
            </Grid></Grid>
    </>);
}